<template>
  <div class="text-center" v-if="showModal">
    <v-dialog
      v-model="showModal"
      max-width="600"
			persistent
      scrollable
    >
      <v-card>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <div class="d-flex flex-row align-center justify-space-between">
							<div class="d-flex flex-row align-center justify-start">
								<v-icon color="warning" class="mr-2">mdi-information</v-icon>
								<p class="mb-0 font-weight-bold text-primary body-1">Gestionar Subcontrato</p>
							</div>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										small
										color="#959595"
										@click="closeModal()"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark>mdi-close</v-icon>
									</v-btn>
								</template>
								<span>Cerrar</span>
							</v-tooltip>
						</div>
						<div v-if="loading">
							<div class="d-flex flex-column justify-center align-center my-4">
								<v-progress-circular
									:size="25"
									:width="3"
									color="rgba(0,0,0,0.2)"
									class="mb-1"
									indeterminate
								></v-progress-circular>
								Cargando Información
							</div>
						</div>
						<div v-else>
							<div class="my-4">
								<div v-if="hasInPreparationContracts">
									<!-- En curso se refiere a que está corriendo ya el contrato -->
									<p class="mb-2">Este proyecto ya tiene un subcontrato en preparación con <b>{{ this.subContractor }}</b></p>
									<p class="mb-1">A continuación, Selecciona los Subcontratos a Incluir en este Nuevo Anexo o Contrato:</p>
									<div class="mb-2 px-2">
										<v-checkbox
											v-for="subcontract in contractorItems"
											:key="subcontract.id"
											v-model="project_subcontract_ids"
											:value="subcontract.id"
											color="black"
											hide-details
											dense
										>
											<template v-slot:label>
												<div v-if="subcontract.subtitle">
													<p class="mb-0" style="font-size: 10px;line-height: 12px;">{{ subcontract.name }}</p>
													<p class="caption font-weight-bold mb-0" v-html="subcontract.subtitle"></p>
												</div>
												<p class="caption font-weight-bold mb-0" v-else>{{ subcontract.name }}</p>
											</template>
										</v-checkbox>
									</div>
									<p class="font-weight-bold mb-0">Los proyectos seleccionados se asignarán al contrato en preparación.</p>
								</div>
								<div v-else>
									<p class="mb-0">Este proyecto no tiene subcontratos en preparación con <b>{{ this.subContractor }}</b>.</p>
									<p class="mb-2">A continuación, puedes seleccionar los subcontratos que se incluirán:</p>
									<div class="mb-2 px-2">
										<v-checkbox
											v-for="subcontract in contractorItems"
											:key="subcontract.id"
											v-model="project_subcontract_ids"
											:value="subcontract.id"
											color="black"
											hide-details
											dense
										>
											<template v-slot:label>
												<div v-if="subcontract.subtitle">
													<p class="mb-0" style="font-size: 10px;line-height: 12px;">{{ subcontract.name }}</p>
													<p class="caption font-weight-bold mb-0" v-html="subcontract.subtitle"></p>
												</div>
												<p class="caption font-weight-bold mb-0" v-else>{{ subcontract.name }}</p>
											</template>
										</v-checkbox>
									</div>
								</div>
							</div>
							<v-divider class="my-2"></v-divider>
							<div>
								<div class="d-flex flex-row justify-space-between">
									<v-btn
										depressed
										dark
										outlined
										color="#959595"
										small
										@click="closeModal()"
									>
										<v-icon dark>mdi-close</v-icon>
										<p class="ml-2 mb-0">Cancelar</p>
									</v-btn>
									<div class="d-flex flex-row justify-end">
										<v-btn
											depressed
											color="#959595"
											small
											class="mr-2"
											:dark="!loadingCreation"
											:disabled="loadingCreation"
											:loading="loadingCreation"
											@click="confirmCreation(1)"
										>
											<v-icon dark>mdi-check</v-icon>
											<p class="ml-2 mb-0">{{hasInPreparationContracts ? 'Confirmar' : 'Nuevo Subcontrato'}}</p>
										</v-btn>
										<!-- <v-btn
											v-if="hasInPreparationContracts"
											depressed
											color="#959595"
											small
											:dark="!loadingCreation"
											:disabled="loadingCreation"
											:loading="loadingCreation"
											@click="confirmCreation(2)"
										>
											<v-icon dark>mdi-check</v-icon>
											<p class="ml-2 mb-0">Nuevo Anexo</p>
										</v-btn> -->
									</div>
								</div>
							</div>
						</div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {checkClosedSubcontracts} from '@/helpers/api/contracts'
export default {
  name: 'ManageSubcontract',
	props: {
		showModal: {
			type: Boolean,
			default: false
		},
		closeModal: {
			type: Function,
		},
		item: {
			type: Object,
			required: true
		},
		project: {
			type: Object,
			required: true
		},
		subcontracts_info: {
			type: Object,
			required: true
		},
		loadingCreation: {
			type: Boolean,
			default: false
		},
		full_subcontracts_info: {
			type: Object,
			required: false
		}
	},
  data: () => ({
		indexModal: + new Date(),
		subcontract: null,
		project_subcontract_ids: [],
		loading: true
  }),
  computed: {
		subContractor(){
			if(this.item.contractor?.profile){
				return this.item.contractor?.profile?.name + ' ' + this.item.contractor?.profile?.lastname + ' ' + this.item.contractor?.profile?.second_lastname	
			}
			return 'Sin Subcontratista'
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		hasInPreparationContracts(){
			return this.subcontract
		},
		filteredFullSubcontractsInfo(){
			let info = {
				mainProjects: [],
				stages: [],
				specialties: [],
				reception: null
			}
			console.log('full_subcontracts_info: ', this.full_subcontracts_info)
			console.log('subcontracts_info: ', this.subcontracts_info)
			if(this.full_subcontracts_info?.reception && !this.full_subcontracts_info.reception.annulated_contract && !this.full_subcontracts_info.reception.deleted_at){
				info.reception = this.full_subcontracts_info.reception
			}
			if(Array.isArray(this.full_subcontracts_info?.mainProjects)){
				info.mainProjects = this.full_subcontracts_info.mainProjects.filter(mp => 
					// !mp.annulated_contract && !mp.deleted_at
					!mp.deleted_at && mp.subcontract?.contract?.last_status?.status !== 11
				)
			}
			if(Array.isArray(this.full_subcontracts_info?.stages)){
				info.stages = this.full_subcontracts_info.stages.filter(stage => 
					// !stage.annulated_contract && !stage.deleted_at
					!stage.deleted_at && stage.subcontract?.contract?.last_status?.status !== 11
				)
			}
			if(Array.isArray(this.full_subcontracts_info?.specialties)){
				info.specialties = this.full_subcontracts_info.specialties.filter(spec => 
					// !spec.annulated_contract && !spec.deleted_at
					!spec.deleted_at && spec.subcontract?.contract?.last_status?.status !== 11
				)
			}
			
			return info
		},
		contractorItems() {
			const contractorId = this.item.contractor_id
			let names = []
			// if (this.subcontracts_info.cost_table && this.subcontracts_info.cost_table.contractor_id === contractorId) {
			// 	names.push({name: this.project?.info?.project_type?.name, subtitle: this.getMainProjectDescription(this.subcontracts_info.cost_table?.cost_table_info), id: this.subcontracts_info.cost_table.id})
			// }
			if (this.filteredFullSubcontractsInfo.reception && this.filteredFullSubcontractsInfo.reception.contractor_id === contractorId) {
				names.push({name: 'Recepción', id: this.filteredFullSubcontractsInfo.reception.id || this.filteredFullSubcontractsInfo.reception.item_id})
			}
			names = names.concat(
				(this.filteredFullSubcontractsInfo.mainProjects || [])
					.filter(main_project => main_project.contractor_id === contractorId)
					.map(main_project => ({
						id: main_project.id || main_project.item_id,
						name: this.getMainProjectTitle(main_project),
						subtitle: this.getMainProjectDescription(main_project)
					}))
			)
			names = names.concat(
				(this.filteredFullSubcontractsInfo.stages || [])
					.filter(stage => stage.contractor_id === contractorId)
					.map(stage => ({
						id: stage.id || stage.item_id,
						name: stage.stage?.stage?.name
					}))
			)
			names = names.concat(
				(this.filteredFullSubcontractsInfo.specialties || [])
					.filter(spec => spec.contractor_id === contractorId)
					.map((spec) => ({
						id: spec.id || spec.item_id,
						name: spec.specialty?.specialty?.name
					}))
			)
			// return names.filter(item => !this.closedSubcontractIds.includes(item.id))
			console.log('filteredFullSubcontractsInfo', this.filteredFullSubcontractsInfo)
			console.log('names', names)
			return names
		},
		closedSubcontractIds() {
			return this.subcontract?.contractor_contract?.flatMap(cc => 
				cc.subcontracts?.map(sub => sub.id) || []
			) || [];
		},
	},
	watch: {
		contractorItems(newValue){
			if(newValue){
			console.log('this.contractorItems', this.contractorItems)
				this.project_subcontract_ids = this.contractorItems
																					// .filter(item => !this.closedSubcontractIds.includes(item.id))
																					.map(item => item.id)
			}
		}
	},
  mounted(){
		this.checkSubcontracts()
		if(this.contractorItems){
			this.project_subcontract_ids = this.contractorItems
																				// .filter(item => !this.closedSubcontractIds.includes(item.id))
																				.map(item => item.id)
		}
  },
  methods: {
		getMainProjectDescription(mainProject){
			return mainProject?.project_table?.project_cost_info?.title || ''
		},
		getMainProjectTitle(mainProject){
      const parentName = mainProject?.project_table?.contract?.info?.project_type?.parent?.name || this.project?.info?.project_type?.parent?.name || '';
      const categoryName = mainProject?.project_table?.contract?.info?.project_type?.category?.name || this.project?.info?.project_type?.category?.name || '';
			const projectTypeName = mainProject?.project_table?.contract?.info?.project_type?.name
      
      if (parentName && categoryName) {
        return `${categoryName} | ${parentName} | ${projectTypeName}`;
      }
      return parentName || categoryName || '';
		},
		confirmCreation(contract_type = 1){
			const data = {
				parent_subcontract_id: this.closedSubcontractIds[0],
				contract_type,
				project_subcontract_ids: this.project_subcontract_ids
			}
			this.$emit('onConfirm', data)
		},
		async checkSubcontracts(){
			this.loading = true
			const sub = await checkClosedSubcontracts({
				parent_contract_id: this.project?.contract?.id,
				contractor_id: this.item?.contractor_id
			})
			if(sub.code == 200){
				this.subcontract = sub.contract || []
				console.log('this.contractorItems', this.contractorItems)
				if(this.contractorItems){
					this.project_subcontract_ids = this.contractorItems
																						// .filter(item => !this.closedSubcontractIds.includes(item.id))
																						.map(item => item.id)
				}
			}
			this.loading = false
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  }
};
</script>

<style scoped>
</style>